import api_url from "../../libary/axios-home";

export const deleteDocumentById = async (id) => {
  const { data } = await api_url.post(`documents/delete/${id}`);
  return data;
};
